<template>
    <div>
        <span class="answer-grey" v-if="label">{{label}}</span>
        <span class="sr-only" v-if="label">.</span>
        <br v-if="label">
        {{ printTextOrBlank(text) }}
        <br>
    </div>
</template>

<script>
    export default {
        name: "BYCItem",
        props: ['label', 'text'],
        methods:{
            printTextOrBlank(text) {
                return !text ? 'blank' : text
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .answer-grey
        color color-4

</style>